import { updateProductList, updateProductAlias } from './productAction';
import { setAliasState, setScanPackMainInputFocus } from './scanpackScanningSetters';
import { extractGtin14FromBarcode } from '../helpers/gs1Barcode';

export function openAddBarcodeWindow(item) {
  return (dispatch) => {
    if (
      (item.barcodes && item.barcodes.length === 0) ||
      (item.barcodes && item.barcodes.length === 1 && item.barcodes[0].barcode === ' ')
    ) {
      dispatch(setScanPackMainInputFocus(false));
      dispatch(setAliasState({ addBarcodeWindow: true, addBarcodeItem: item }));
    }
  };
}

export function addBarcodeSubmit() {
  return (dispatch, getState) => {
    const { addBarcodeText, addBarcodeItem } = getState().scanPackScanning.alias;
    const gtin14 = extractGtin14FromBarcode(addBarcodeText);
    dispatch(updateProductList({
      value: gtin14 || addBarcodeText,
      var: 'barcode',
      id: addBarcodeItem?.product_id
    }));
  };
}

export function proceedAliasing() {
  return (dispatch, getState) => {
    const { productData } = getState().scanPackScanning.alias;
    const aliasProductId = productData?.alias_product_data?.id;
    const currentProductId = productData?.current_product_data?.id;
    dispatch(updateProductAlias(aliasProductId, { product_alias_ids: [currentProductId] }));
    dispatch(setAliasState({
      aliasVisible: false,
      shareBarcodeShow: false,
      addBarcodeWindow: false,
      addBarcodeText: '',
      addBarcodeItem: null,
      productData: null
    }));
  };
}

export function sameBarcode() {
  return (dispatch, getState) => {
    const { addBarcodeText, addBarcodeItem } = getState().scanPackScanning.alias;
    const gtin14 = extractGtin14FromBarcode(addBarcodeText);
    dispatch(updateProductList({
      value: gtin14 || addBarcodeText,
      var: 'barcode',
      id: addBarcodeItem?.product_id,
      permit_same_barcode: true
    }));
    dispatch(setAliasState({
      shareBarcodeShow: false,
      aliasVisible: false
    }));
  };
}

export function shareBarcodeMethod() {
  return (dispatch) => {
    dispatch(setAliasState({ shareBarcodeShow: true, aliasVisible: false }));
  };
}

export function assignUniquebarcode() {
  return (dispatch) => {
    dispatch(setAliasState({
      shareBarcodeShow: false,
      aliasVisible: false,
      addBarcodeWindow: false,
      addBarcodeText: '',
      addBarcodeItem: null,
      productData: null
    }));
  };
}
